import { AnimatePresence, motion, useReducedMotion } from 'motion/react'
import type { LieferstellenKind } from '../api/lieferstellenApi'
import { KINDS } from './lieferstellenUi'

const EASE = [0.2, 0.8, 0.2, 1] as const

/** White filled icon inside a circle in the kind colour: the one look for chip, pin, row and phone button. */
export function KindBadge({ kind, size = 28 }: { kind: LieferstellenKind; size?: number }) {
  return (
    <span aria-hidden="true" className="inline-flex shrink-0 items-center justify-center rounded-full"
      style={{ width: size, height: size, backgroundColor: KINDS[kind].color }}>
      <span className="material-symbols-outlined" style={{ fontSize: Math.round(size * 0.6), color: '#ffffff', fontVariationSettings: "'FILL' 1" }}>{KINDS[kind].icon}</span>
    </span>
  )
}

/** Calm confirmation pill: fades up, no bounce. Clears itself through the parent. */
export function Toast({ message, top = false }: { message: string; top?: boolean }) {
  const reduce = useReducedMotion()
  return (
    <div className={`pointer-events-none absolute inset-x-0 z-10 flex justify-center px-3 ${top ? 'top-32' : 'bottom-6'}`}>
      <AnimatePresence>
        {message && (
          <motion.div key={message} aria-hidden="true"
            initial={reduce ? false : { opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
            transition={{ duration: reduce ? 0 : 0.24, ease: EASE }}
            className="inline-flex max-w-full items-center gap-2 rounded-full bg-white px-4 py-2.5 text-sm font-medium text-on-surface shadow-lg">
            <span className="material-symbols-outlined !text-xl shrink-0" style={{ color: '#047857' }}>check_circle</span>
            <span className="min-w-0 break-words">{message}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
